import React from 'react';
import { Container, BlueRightBorder, OrangeRightBorder } from './Styles';
import useCurrentTradeContext from '../../../_shared/hooks/trade/useCurrentTradeContext';
import { TradeContext } from '../../../_shared/types/trade';

const CardHighlight = () => {
  const tradeContext = useCurrentTradeContext();
  const showBlue = tradeContext === TradeContext.Sell;
  const showOrange = tradeContext === TradeContext.Buy;
  return (
    <Container>
      {showOrange && <OrangeRightBorder />}
      {showBlue && <BlueRightBorder />}
    </Container>
  );
};

export default CardHighlight;
